import React, { useState } from 'react'
import { Rupee } from '../../Componets'
import errorName, { base_loading_time, url } from '../../base/Variables'
import { LazyAxios, catchError, getToken, InfoPopUp, LazyImage, LikeIcon, setDefaultAll, slugify, StartLoading } from '../../base'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

const OrderItem = React.memo(({ item, inquiryPage = false }) => {
    const navigate = useNavigate()
    const [popUpMessage, setPopUpMessage] = useState(null)
    const [fav, setFav] = useState(false)
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()

    async function actionOnWishList(action) {
        setLoading(true)
        try {
            const token = getToken()
            const axios = await LazyAxios()
            const request = await axios.put(`${url}/api/v1/user/wishlist/?product_id=${item.product_id}&action=${action}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (request.data && request.data.success_message) {
                action === 'remove' ? setFav(false) : setFav(true)
                setPopUpMessage(request.data.success_message)
            }
            else if (request.data && request.data.product === null) {
                setPopUpMessage('Oops! Product has been deleted.')
            }
            else if (request.data && request.data.error_message) {
                setPopUpMessage(request.data.error_message)
            }
        }
        catch (error) {
            const error_message = catchError(error).error_message
            if (error_message === errorName.authenticationError || error_message === errorName.notNormalUser || error_message === errorName.userNotFound) {
                setDefaultAll(dispatch, true)
                setPopUpMessage(error_message)
            }
            else {
                setPopUpMessage(error_message)
            }
        }
        finally {
            const timeout = setTimeout(() => {
                setLoading(false)
            }, [base_loading_time])
            return () => clearTimeout(timeout)
        }

    }
    console.log(item.available)
    return (
        <>
            {
                item && <div className='cartItem'>
                    <div className='d-flex' style={{ rowGap: '10px' }}>
                        <div>
                            <div className='imagediv'>
                                <LazyImage src={`${url}${item.product_image}`} alt={item.product_name} />
                            </div>
                        </div>
                        <div className='ms-2 w-100 d-flex position-relative' style={{ flexDirection: 'column', justifyContent: 'space-evenly', paddingRight: '5px' }}>
                            <div className='h7 scolor truncate-2' style={{ cursor: 'pointer' }} onClick={() => navigate(`/product/${slugify(item.product_name, item.product_id)}/details/`)}>{item.product_name}</div>
                            <div className='smallText truncate-2' style={{ cursor: 'pointer' }} onClick={() => navigate(`/shop/${slugify(item.shop_name, item.shop_id, false)}/details/`)}>Seller : {item.shop_name}</div>
                            <div className='h7'>Quantity : {item.quantity}</div>
                            <div className='h7 d-flex gap-1 '>Price : <Rupee className='ms-2' amount={item.price} /></div>
                            <div className='h7 d-flex gap-1 '>Total : <Rupee className='ms-2' amount={item.price * item.quantity} /></div>
                            <span className='position-absolute' style={{ right: '10px', bottom: '5px' }} onClick={() => actionOnWishList(fav ? 'remove' : 'add')}><LikeIcon className={fav && 'fav'} /></span>
                        </div>
                    </div>
                </div>
            }

            {inquiryPage === false && <div className='smallText mt-2 text-center'>{item.available === item.quantity ? '' : item.available > 0 && item.available < item.quantity ? `Only ${item.available} in stock, we will proceed order with this quantity` : 'Sorry, Above item is not available, Move it to wishlist'}</div>}
            {
                loading ? <StartLoading /> : popUpMessage ? <InfoPopUp popUpMessage={popUpMessage} setPopUpMessage={setPopUpMessage} /> : <></>
            }
        </>
    )
})

export default OrderItem